<div *ngIf="clientLoaded" class="app-ui-wrapper">
    <app-navbar></app-navbar>

    <div class="main-content">
        <router-outlet></router-outlet>
    </div>

    <app-footer *ngIf="!loader" class="app-footer" [clientObject]="clientService.client">
    </app-footer>

    <div *ngIf="loader">
        <mat-spinner mode="indeterminate" diameter="30"></mat-spinner>
    </div>
    <app-cookie-dialog></app-cookie-dialog>
</div>